import React from "react";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import styles from "./RegistrationNumberDialog.module.scss";
import Button from "@material-ui/core/Button";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import DatePicker, { CalendarContainer } from "react-datepicker";
import { withTranslation } from "react-i18next";
import * as DateConstants from "../../../../../../shared/constants/DateConstants";
import UiDateUtils from "../../../../../../utils/UiDateUtils";
import {
  TRANSLATED_DAYS,
  TRANSLATED_MONTHS,
} from "../../../../../../common/Constants";

const CloseButton = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

class RegistrationNumberDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dateOfReg: undefined,
      registrationNumber: undefined,
    };
    this.days = TRANSLATED_DAYS.map((days) => this.props.t(days.label));
    this.months = TRANSLATED_MONTHS.map((months) => this.props.t(months.label));
    this.locale = {
      localize: {
        day: (n) => this.days[n],
        month: (n) => this.months[n],
      },
      formatLong: {},
    };
  }

  handleRegistrationNumber = (e) =>
    this.setState({ registrationNumber: e.target.value });

  setDateOfReg = (e) => this.setState({ dateOfReg: new Date(e) });

  resetInput = () =>
    this.setState({ dateOfReg: undefined, registrationNumber: undefined });

  closeRegistrationDialog = () => {
    this.resetInput();
    this.props.close();
  };

  isConfirmButtonEnabled = () =>
    this.state.dateOfReg && this.state.registrationNumber;

  saveRegistrationData = (number) => {
    const year = this.state.dateOfReg.getFullYear();
    const month = this.state.dateOfReg.getMonth() + 1;
    const day = this.state.dateOfReg.getDate();
    const formattedDateFce = UiDateUtils.formatDateDDMMYYYWithOutDashes(
      year,
      month,
      day
    );
    const formattedDateSAP = UiDateUtils.formatDateYYYYMMDD(year, month, day);
    this.props.saveRegistrationData(
      number,
      formattedDateFce,
      UiDateUtils.saveDateFormat(formattedDateSAP)
    );
  };

  render() {
    const fromNscDealerSearch =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "financeRegistrationSubmit"
      ) && this.props.fromNscDealerSearch;

    const Container = ({ children }) => {
      return (
        <div className="dialogContainer">
          <CalendarContainer>
            <div className="calendarContainer">{children}</div>
          </CalendarContainer>
        </div>
      );
    };

    return (
      <Dialog
        className={styles.dialogContainer}
        open={this.props.open}
        onClose={this.closeRegistrationDialog}
      >
        <div className={styles.dialogWrapper}>
          <button
            className={styles.cancel}
            data-testid="closeDialog"
            onClick={this.closeRegistrationDialog}
          >
            <CloseButton />
          </button>

          <div className={styles.dialogTitle}>
            <div>{this.props.t("PMRegistrationNumber.title")}</div>
          </div>

          <div className={styles.dialogDescription}>
            {this.props.t("PMRegistrationNumber.dialogDescription")}
          </div>

          <ValidatorForm
            id="registrationNumberForm"
            onSubmit={() =>
              this.saveRegistrationData(this.state.registrationNumber)
            }
          >
            <div className={styles.inputLabel}>
              {this.props.t("PMRegistrationNumber.number")}
            </div>

            <div className={styles.textBox}>
              <TextValidator
                placeholder="Eg. SG2X C34"
                name="registrationNumber"
                autoComplete="off"
                value={this.state.registrationNumber}
                disabled={false}
                className={styles.registrationNumberInput}
                variant="outlined"
                onChange={this.handleRegistrationNumber}
                validators={["required", "matchRegexp:^[A-Za-z0-9\\b]+$"]}
                errorMessages={[
                  this.props.t("PMRegistrationNumber.errorReq"),
                  this.props.t("PMRegistrationNumber.validReg"),
                ]}
              />
            </div>

            <div className={styles.inputLabel}>
              {this.props.t("PMRegistrationNumber.dateOfReg")}
            </div>

            <div
              data-testid="calendar"
              className={`datePickerDialogStyles ${styles.calendar}`}
            >
              <DatePicker
                placeholderText={DateConstants.DD_MM_YYYY}
                name="datePicker"
                locale={this.locale}
                selected={this.state.dateOfReg}
                withPortal
                dateFormat={DateConstants.ddMMyyyy}
                shouldCloseOnSelect={true}
                maxDate={this.props.maxDate}
                minDate={this.props.minDate}
                onChange={this.setDateOfReg}
                calendarContainer={Container}
              />
            </div>

            <div className={styles.dialogActions}>
              <Button
                className={styles.backBtn}
                name="back"
                data-testid="registrationNumberBack"
                onClick={this.closeRegistrationDialog}
              >
                {this.props.t("PMRegistrationNumber.back")}
              </Button>
              <Button
                className={styles.confirmBtn}
                type="submit"
                name="confirm-btn"
                data-testid="registrationNumber-confirm-btn"
                disabled={!this.isConfirmButtonEnabled() || fromNscDealerSearch}
              >
                {this.props.t("PMRegistrationNumber.confirm")}
              </Button>
            </div>
          </ValidatorForm>
        </div>
      </Dialog>
    );
  }
}

export default withTranslation("emp")(RegistrationNumberDialog);
